import styled from "@emotion/styled";

export const StyledToggleBlock = styled.label`
  display: flex;
  align-items: center;
  line-height: 16.41px;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
`;
